import Icon from '../../Icon/Icon.js';
import { MealsContainer, MealsItem, MealsItemPackage, MealsItemPackageExt } from './styles/hotelHitContentBodyMeals.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { USER_INTERFACE_TICK_DONE } from '../../IconPath/USER_INTERFACE_TICK_DONE.js';

var HotelHitContentBodyMeals = function HotelHitContentBodyMeals(_ref) {
  var _ref$texts = _ref.texts,
    packageDescriptionText = _ref$texts.packageDescriptionText,
    packageIncludedText = _ref$texts.packageIncludedText,
    ancillaryText = _ref$texts.ancillaryText,
    ancillaryExtensionText = _ref$texts.ancillaryExtensionText;
  return /*#__PURE__*/jsxs(MealsContainer, {
    children: [packageDescriptionText && /*#__PURE__*/jsxs(MealsItem, {
      included: true,
      children: [/*#__PURE__*/jsxs(MealsItemPackage, {
        children: [/*#__PURE__*/jsx(Icon, {
          path: USER_INTERFACE_TICK_DONE,
          className: "sg-hotel-hit__meals-icon"
        }), packageDescriptionText]
      }), packageIncludedText && /*#__PURE__*/jsx(MealsItemPackageExt, {
        children: packageIncludedText
      }), "\xA0"]
    }), ancillaryText && /*#__PURE__*/jsxs(MealsItem, {
      children: [/*#__PURE__*/jsx(MealsItemPackage, {
        children: ancillaryText
      }), ancillaryExtensionText && /*#__PURE__*/jsx(MealsItemPackageExt, {
        children: ancillaryExtensionText
      })]
    })]
  });
};
HotelHitContentBodyMeals.defaultProps = {
  texts: null
};
var HotelHitContentBodyMeals$1 = HotelHitContentBodyMeals;

export { HotelHitContentBodyMeals$1 as default };
//# sourceMappingURL=HotelHitContentBodyMeals.js.map
